export { ChevronRight1 } from "./ChevronRight1";
